// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"395":"f2ef0ab5","469":"00e32fae","963":"461fc755"}[chunkId] + ".chunk.css";
};